import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { tap } from 'rxjs';
import { EducationService } from 'src/app/shared/services/education.service';
import { LoadingService } from 'src/app/shared/services/loading.service';

import {AngularTiptapEditorComponent, AteI18nService} from "@flogeez/angular-tiptap-editor";
import {FormsModule} from "@angular/forms";
import {SafeHtml} from "../../../../../shared/pipes/SafeHtml";
import {LyDialog} from "@alyle/ui/dialog";
import {LyOverlay} from "@alyle/ui";
import {tiptapEditorConfig, initTiptapI18n} from "../../../../../shared/helpers/helpers";


@Component({
    selector: 'app-lesson-content-item-text',
    templateUrl: './lesson-content-item-text.component.html',
    styleUrls: ['./lesson-content-item-text.component.scss'],
    standalone: true,
    imports: [
    AngularTiptapEditorComponent,
    FormsModule,
    SafeHtml
],
    providers: [
        { provide: LyDialog },
        { provide: LyOverlay },
    ]
})
export class LessonContentItemTextComponent implements OnInit {

  editorConfig = tiptapEditorConfig;

  @Input() ItemUid: string = '';
  @Input() ItemData: any = null;
  @Input() IsSelected = false;


  @Output() OnChanged = new EventEmitter<any>();

  InitText: any = null;

  constructor(
    public loadingService: LoadingService,
    private educationService: EducationService,
    private i18n: AteI18nService,
  ) {
    initTiptapI18n(this.i18n);
  }

  ngOnInit(): void {
    this.InitText = this.ItemData;

  }

  get hasChanged() { return this.InitText != this.ItemData };

  changeText() {
    this.ChangeItem().subscribe()
  }

  cancelChangeText () {
    this.ItemData = this.InitText;
    this.OnChanged.emit(this.ItemData)
  }

  ChangeItem() {
    const form = new FormData();
    form.append('content', String(this.ItemData));

    return this.educationService.EditLessonContentData(this.ItemUid, form)
        .pipe(
          tap((res) => {
            this.InitText = this.ItemData;
            this.OnChanged.emit(this.ItemData)
          })
    )
  }

  onContentChange(content: string) {
    this.ItemData = content;
  }

  ResetFocus(e:any){
    //console.log("ResetFocus",e)

  }


}
